import React, { Component} from "react";
import CheckMarkIcon from 'assets/img/check-mark.svg'
import {BUSINESS_OWNER_INFO_TITLE, PERSONAL_INFO_TITLE} from '../../Step2/constants';
import PersonalInfoForm from "components/PersonalInfoForm";
import { validate} from "utils/validations";
import './styles.scss'
import PersonalInfoIcon from '../../../../assets/img/personal-info-icon.png';
import {BlueBtn} from '../../../../components/Controls';
import RightArrow from '../../../../assets/img/icon-arrow-right.svg';
import { connect } from 'react-redux';
import {formValueSelector, reduxForm} from 'redux-form';
import {b2bSelector, formValuesSelector} from 'containers/MultistepForm/selectors.js';

const selector = formValueSelector('form')

class PersonalInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: true,
    };
  }

  onSubmit = () => {
    const { financialInfoBoxHandlerOpen } = this.props;
    financialInfoBoxHandlerOpen();
    this.handleBoxClose();
  }

  handleBoxClose = () => {
      this.setState({ visible: false});
  }

  handleEdit = () => {
    const { financialInfoBoxHandlerClose } = this.props;
    this.setState({ visible: true});
    financialInfoBoxHandlerClose()
  }

  render() {
    const { month, day, year, change, valid, b2b } = this.props;

    return (
      <div className="personal-info-box">
        {!this.state.visible &&
          <div className="paypair-form personal-info-collapse">
            <div className="form-item-group">
              <div className="personal-info-text">
                <div className="personal-info-2">
                  <img className="personal-info-icon" src={CheckMarkIcon}/>
                </div>
                {b2b ? (
                  <div className="personal-info"><strong>{BUSINESS_OWNER_INFO_TITLE}</strong></div>
                ) : (
                  <div className="personal-info"><strong>{PERSONAL_INFO_TITLE}</strong></div>
                )}
              </div>
              <div className="edit-link">
                <a href="#" type="submit" onClick={this.handleEdit}>Edit</a>
              </div>
            </div>
          </div>
        }
        { this.state.visible && (
            <div>
              <div className="personal-info-string">
                <div className="personal-info-2">
                  <img className="personal-info-icon" src={PersonalInfoIcon}/>
                </div>
                {b2b ? (
                  <div className="personal-info"><strong>{BUSINESS_OWNER_INFO_TITLE}</strong></div>
                ) : (
                  <div className="personal-info"><strong>{PERSONAL_INFO_TITLE}</strong></div>
                )}
              </div>
              <PersonalInfoForm month={month} day={day} year={year} change={change} />
              {!b2b && (
                <div className="paypair-form">
                  <div className="submit-btn form-item-group">
                    <div className="form-item form-item--state">
                      <div className="personal-info-button">
                        <BlueBtn
                          customClass="step2__submit-btn"
                          type="submit"
                          disabled={!valid}
                          onClick={this.onSubmit}
                        >
                          Continue <img src={RightArrow} className="right-arrow"/>
                        </BlueBtn>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )
        }
      </div>
    )
  }
}


const mapStateToProps = (state) => ({
  values: formValuesSelector()(state),
  month: selector(state, 'month'),
  day: selector(state, 'day'),
  year: selector(state, 'year'),
  b2b: b2bSelector()(state),
});

PersonalInfo = connect(mapStateToProps, null)(PersonalInfo)

PersonalInfo = reduxForm({
  validate,
  form: "form",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(PersonalInfo);


export default PersonalInfo;
